import React from "react";

function NewsLetterArea() {
  return (
    <section
      className="newsletter-area jarallax newsletter-bg"
      style={{
        backgroundImage: `url(${require("../../assets/img/bg/newsletter_bg.jpg")})`,
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-5">
            <div className="newsletter-content">
              <div className="section-title white-title-two tg-heading-subheading animation-style3">
                <span className="sub-title tg-element-title">
                  Connnect with us
                </span>
                <h2 className="title tg-element-title">
                  Any Enquiries Regarding Our  Services?
                </h2>
              </div>
            </div>
          </div>
          <div className="col-xl-7">
            <div className="newsletter-form">
              <form action="#">
                <div className="form-grp">
                  <input type="text" placeholder="Name*" />
                </div>
                <div className="form-grp">
                  <input type="text" placeholder="Phone*" />
                </div>
                <button type="submit" className="btn btn-two">
                  Submit Now
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsLetterArea;
